import auth from "@/api/auth";

const USER_INCLUDES =
  "companies.contactPrepaidCards,companies.contactLoyaltyCards,companies.contactOffers";

const state = {
  user: null,
  token: ""
};

const getters = {
  token: state => {
    return state.token;
  },
  user: state => {
    return state.user;
  }
};

const actions = {
  login({ commit }, data) {
    return auth
      .login(data)
      .then(response => {
        if (response.status === 200) {
          commit("SET_USER", response.data);
        }
        return response;
      })
      .catch(error => {
        console.log("error " + error);
        return error;
      });
  },

  register({ commit }, data) {
    return auth
      .register(data)
      .then(response => {
        if (response.status === 200) {
          commit("SET_USER", response.data);
        }
        return response;
      })
      .catch(error => {
        console.log("error " + error);
        return error;
      });
  },

  user({ commit }, payload) {
    const defaultInclude = USER_INCLUDES;
    let include = defaultInclude;
    let shouldCommit = true;

    if (typeof payload === "string") {
      include = payload;
    } else if (payload && typeof payload === "object") {
      if (payload.include !== undefined) {
        include = payload.include;
      }
      if (payload.commit === false) {
        shouldCommit = false;
      }
    }

    const params =
      include === null || include === ""
        ? {}
        : { include };

    return auth
      .user(params)
      .then(response => {
        if (response.status === 200 && shouldCommit) {
          commit("SET_USER", response.data);
        }
        return response;
      })
      .catch(error => {
        console.log("error " + error);
        const status = error.response && error.response.status;
        if (shouldCommit) {
          commit("SET_USER", null);
        } else if (status === 401) {
          commit("SET_USER", null);
        }
        return error.response;
      });
  },

  logout({ commit }, data) {
    return auth
      .logout(data)
      .then(response => {
        commit("SET_USER", null);
        return response;
      })
      .catch(error => {
        console.log("error " + error);
        return error;
      });
  }
};

const mutations = {
  SET_USER(state, value) {
    state.user = value;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
